import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSectionKeyword = ({
  title = "What Our Customers Say",
  subtitle  = "Testimonial",
  testimonials = [],
  autoplay = true,
  autoplaySpeed = 3000,
}) => {
  const renderStars = (count) => {
    return Array.from({ length: count }).map((_, i) => (
      <span key={i} className="star">
        <i className="fa fa-star"></i>
      </span>
    ));
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: autoplay,
    autoplaySpeed: autoplaySpeed,
    pauseOnHover: true,
    fade: true, // Smooth fade transition between slides
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="testimonial-section py-5">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div className="section-head mb-5">
              <div className="section-subtitle darkcolor">{subtitle}</div>
              <h2 className="section-title ">{title}</h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Slider {...sliderSettings}>
              {testimonials.map((testimonial) => (
                <div className="testimonial-item" key={testimonial.id}>
                  <div className="testimonial-card p-4">
                    <div className="testimonial-header mb-4">
                      <div className="testimonial-author">
                        <h3 className="author-name darkcolor">{testimonial.name}</h3>
                        <div className="author-position">{testimonial.position}</div>
                      </div>
                    </div>

                    <div className="testimonial-body mb-4">
                      <p className="testimonial-feedback">{testimonial.feedback}</p>
                      <div className="testimonial-rating">
                        {renderStars(testimonial.rating)}
                      </div>
                    </div>
                   
                    {/* <div className="testimonial-quote">
                      <img src="images/quote.png" alt="Quote" />
                    </div> */}
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSectionKeyword;




